module.exports = __webpack_public_path__ + "494cd07c/img/dollar-icon.35c9d638.svg";